<div class="card-header">
  <app-breadcrumb currentPage="rapporten"></app-breadcrumb>

  <ng-container *ngIf="userService.isAdmin()">
    <div class="menu" [matMenuTriggerFor]="menu">
      <span class="material-icons white">more_vert</span>
    </div>
    <mat-menu #menu="matMenu" xPosition="before">
      <button mat-menu-item routerLink="bewerken">
        <mat-icon>edit</mat-icon>
        <span>rapporten bewerken</span>
      </button>
    </mat-menu>
  </ng-container>
</div>

<div class="card-body">
  <div>
    <div class="section-header">boedelbeschrijving</div>
    <div class="section-body">
      <p>
        De boedelbeschrijving is een overzicht van alle bezittingen en schulden van de betrokkene bij aanvang van het
        bewind of de onder curatele stelling. Uiterlijk 4 maanden na uw benoeming tot bewindvoerder moet u de
        boedelbeschrijving hebben ingediend bij de rechtbank. <br>
        Als u vragen heeft over het maken van een
        boedelbeschrijving bekijk dan
        <a class="link" href="https://www.reveon.nl/help/rapportages/rapport-boedelbeschrijving" target="_blank">
          deze pagina
        </a>
        of stuur een mail aan
        <a class="link" href="mailto:info@reveon.nl">info@reveon.nl</a>.
      </p>

      <app-report-list-item [clientId]="clientId"
                            [reports]="reportMap.get(codeEnum.Bb)">
      </app-report-list-item>
      <!-- only show message for belanghebbende since users can create one with the button below -->
      <ng-container *ngIf="reportMap.get(codeEnum.Bb).length == 0">
        <div *ngIf="immutable">
          <div class="spacer-small"></div>
          <strong>
            Er staat momenteel nog geen boedelbeschrijving voor u open. Klopt dit niet? Neem dan contact met ons op via
            <a class="link" href="mailto:info@reveon.nl">info@reveon.nl</a>
          </strong>
        </div>
        <div *ngIf="!immutable">
          <button (click)="createBb()" class="btn plus btn-left mt14">boedelbeschrijving aanmaken</button>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="spacer"></div>

  <div>
    <div class="section-header">rekening & Verantwoording</div>
    <div class="section-body">
      <p>
        Jaarlijks geeft u aan de rechtbank doormiddel van een rekening en verantwoordingsrapportage een inzage in de
        financiën van betrokkene. In een rekening en verantwoordingsrapportage maakt u over het rapportagejaar een
        overzicht van:
      </p>
      <ul>
        <li>de inkomsten en uitgaven</li>
        <li>het bezit van de betrokkene</li>
        <li>de schulden, als deze er zijn</li>
      </ul>
      <p>
        Als u vragen heeft over het maken van een rekening en verantwoording bekijk dan
        <a class="link" href="https://www.reveon.nl/help/rapportages/rapport-rekening-verantwoording" target="_blank">
          deze pagina
        </a>
        of stuur een mail aan
        <a class="link" href="mailto:info@reveon.nl">info@reveon.nl</a>.
      </p>
      <app-report-list-item [clientId]="clientId"
                            [reports]="reportMap.get(codeEnum.Rv)">
      </app-report-list-item>

      <div *ngIf="reportMap.get(codeEnum.Rv).length == 0">
        <div class="spacer-small"></div>
        <strong>
          Er staat momenteel nog geen rekening en verantwoording voor u open. Klopt dit niet? Neem dan contact met ons
          op via <a class="link" href="mailto:info@reveon.nl">info@reveon.nl</a>
        </strong>
      </div>

    </div>
  </div>
  <div class="spacer"></div>


  <div>
    <div class="section-header">vijfjaarlijkse evaluatie</div>
    <div class="section-body">
      <p>Eens in de vijf jaar vraagt de kantonrechter aan u om het formulier vijfjaarlijkse evaluatie in te vullen.
        Hierin geeft u aan hoe het bewind verloopt, of het bewind nog nodig is of niet meer voldoet.</p>
      <p>
      <p>
        Als u vragen heeft over het maken van een vijfjaarlijkse evaluatie bekijk dan
        <a class="link" target="_blank" href="https://www.reveon.nl/help/rapportages/rapport-vijfjaarlijkse-evaluatie">
          deze pagina
        </a>
        of stuur een mail aan
        <a class="link" href="mailto:info@reveon.nl">info@reveon.nl</a>
      </p>
      <app-report-list-item [clientId]="clientId"
                            [reports]="reportMap.get(codeEnum.Vje)">
      </app-report-list-item>

      <div *ngIf="reportMap.get(codeEnum.Vje).length == 0">
        <div class="spacer-small"></div>
        <strong>
          Er staat momenteel nog geen vijfjaarlijkse evaluatie voor u open. Klopt dit niet? Neem dan contact met ons op
          via <a class="link" href="mailto:info@reveon.nl">info@reveon.nl</a>
        </strong>
      </div>

    </div>
  </div>
  <div class="spacer"></div>

  <div>
    <div class="section-header">eindrekening en verantwoording</div>
    <div class="section-body">
      <div>
        <p>
          Een eindrekening en verantwoording is een overzicht van het inkomen, de uitgaven, bezittingen, vorderingen en
          schulden van de betrokkene over de laatste periode van het bewind of de curatele. U maakt de eindrekening en
          verantwoording als het bewind of de curatele stopt of u als bewindvoerder of curator stopt. Of als de
          betrokkene is overleden. <br>
          Als u vragen heeft over het maken van een eindrekening en verantwoording bekijk dan
          <a class="link" href="https://www.reveon.nl/help/rapportages/rapport-eindrekening-verantwoording"
             target="_blank">
            deze pagina
          </a>
          of stuur een mail aan
          <a class="link" href="mailto:info@reveon.nl">info@reveon.nl</a>
        </p>

        <ng-container *ngIf="reportMap.get(codeEnum.Erv).length === 0 && reportMap.get(codeEnum.Ervo).length  === 0">
          <div *ngIf="!immutable">
            <button (click)="createErv()" class="btn times btn-left mt14">eindrekening en verantwoording aanmaken
            </button>
          </div>
          <div *ngIf="immutable">
            <div class="spacer-small"></div>
            <strong>
              Er staat momenteel nog geen eindrekening en verantwoording voor u open. Klopt dit niet? Neem dan contact
              met ons op via <a class="link" href="mailto:info@reveon.nl">info@reveon.nl</a>
            </strong>
          </div>
        </ng-container>

        <app-report-list-item *ngIf="reportMap.get(codeEnum.Erv).length > 0"
                              [clientId]="clientId"
                              [reports]="reportMap.get(codeEnum.Erv)">
        </app-report-list-item>

        <app-report-list-item *ngIf="reportMap.get(codeEnum.Ervo).length > 0"
                              [clientId]="clientId"
                              [reports]="reportMap.get(codeEnum.Ervo)">
        </app-report-list-item>
      </div>
    </div>
  </div>

  <div class="spacer"></div>
  <div>
    <div class="section-header">verplicht informeren van de kantonrechter</div>
    <div class="section-body">
      <div>
        <p>U bent verplicht de kantonrechter direct te informeren in de volgende situaties:</p>
        <ul>
          <li>bij overlijden van de betrokkene of de tweede bewindvoerder</li>
          <li>bij verhuizing door de betrokkene of door u</li>
          <li>als u uw taken voor lange tijd niet kunt uitvoeren, bijvoorbeeld door ziekte</li>
          <li>als het bewind niet meer nodig is</li>
          <li>als het bewind niet voldoende is en u bewind wilt omzetten naar curatele</li>
        </ul>
        Informeer de kantonrechter per brief.
      </div>
    </div>
  </div>
</div>
